// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Dj0V","inner":"styles_inner__3GboW","right":"styles_right__1mCtP","close":"styles_close__15aL-","footer":"styles_footer__14Otk"};